import Banner from '../Banner';
import { AutocompleteModel, TraitTypeAutocomplete } from '../traits/autocomplete';

function traits() {
  const traits = [
    {
      type: TraitTypeAutocomplete,
      model: AutocompleteModel.banner,
      placeholder: 'Select a banner...',
      label: 'Banner',
      name: 'banner_id',
      required: true,
    },
  ];

  return traits;
}

function componentDefinition(editor, options) {
  const { componentType, componentName } = options;
  return {
    extend: 'react-component',
    model: {
      defaults: {
        'custom-name': componentName,
        component: Banner,
        traits: traits(),
      },
    },
    isComponent: el => el.tagName === componentType.toUpperCase()
  }
}

export default function (editor, options) {
  editor.Components.addType(options.componentType, componentDefinition(editor, options));
}
